import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  list(options?: ApiSchemas['ListMedicineCategoryDto']) {
    return wrapEndpoint(() => client.GET('/medicine-category', { params: { query: options } }))
  },
}
